import React from 'react';
import { useState } from 'react';
import Navigation from './Navigation';
import './home.css'; 
import market from './market.jpg';
import register from './register.jpg';
import access from './access.jpg';
import achieve from './achieve.jpg';
import partners from './partners.jpg';
import pricing from './pricing.jpg';
import analysis from './analysis.jpg';
import send from './send.png';
import save from './save-money.png';
import secure from './secure-shield.png'
function Home() {
  const [isYearly, setIsYearly] = useState(false);

  const handleYearlyClick = () => {
    setIsYearly(true);
  };

  const handleMonthlyClick = () => {
    setIsYearly(false);
  };

  return (
    <div>
      <Navigation />
      <div className="main-content">
        <div className="text-content">
        <h1 style={{fontSize:"40px"}}> Navigating Microsoft  <br/>
                Marketplace with a Snap!</h1>
          <p>
            Publish in Days , not in months!
          </p>
          <button className="discover-button" ><a href="https://marketserve-tool.cloudservesystems.com/login/" style={{textDecoration:'none', color:"#222"}} >Publish Now!</a></button>
        </div>
        <div className="image-content">
          <img
            src={market}
            alt="Image Alt Text"
            style={{width:'550px'}}
          />
        </div>
      </div>
      
      <br/>
      <div className="marketserve-box">
        <h1>MarketServe</h1>
        <p>An application which publishes and manages products on Microsoft marketplaces.</p>
        <p>Publishing your SaaS offering on the Microsoft marketplace grants your platform access to a vast user base of millions.</p>
        <p>Marketserve Marketplace Companion is an innovative automation solution designed to streamline the publication process on the marketplace, eliminating the need to dedicate precious time to fulfillment details.</p>
        <p>With Marketserve, your team can focus on what truly matters - enhancing your product's features - while our platform handles the intricate task of marketplace publication.</p>
        <p>In addition to our cutting-edge automation solution, a dedicated success manager from Marketserve will be available to guide you through the publication process, ensuring a seamless and expeditious experience for your product's launch.</p>
      </div>

      <div className="marketserve-section">
    <h1>Why Choose Marketserve?</h1>
    <ul>
    <li>
      <h2>Time-Saving Automation:</h2>
      <p>Say goodbye to the time-consuming task of managing marketplace publication details. Let Marketserve handle it for you.</p>
    </li>
    <li>
      <h2>Wide Audience Reach:</h2>
      <p>Tap into the vast Microsoft marketplace user base and increase your product's visibility.</p>
    </li>
    <li>
      <h2>Focus on Product Enhancement:</h2>
      <p>Concentrate on improving your SaaS product's features while Marketserve takes care of the publishing process.</p>
    </li>
    <li>
      <h2>Expert Guidance:</h2>
      <p>Benefit from the expertise of a dedicated success manager who will ensure a smooth product launch.</p>
    </li>
  </ul>
</div>

      <br/> <br/>
      <h1>Distribute your SaaS product to a wide audience effortlessly <br/>using only a handful of clicks!</h1>
       
        <div className="main-content">
        <div className="image-row">
          <div className="image-content">
            <img src={register} alt="Image 1 Alt Text" />
            <h3>Register</h3>
                <p>Our "register" process is quick.
                    It ensures your<br/> business informations
                    are up-to-date for publishing.</p>
          </div>
          <div className="image-content">
            <img src={access} alt="Image 2 Alt Text" />
            <h3>Access</h3>
               <p>With our user-friendly platform, you'll
                be managing and <br/>extending offers
                to your customers like a boss.
              </p>
          </div>
          <div className="image-content">
            <img src={achieve} alt="Image 3 Alt Text" />
            <h3>Achieve</h3>
                  <p>Receive unparalleled Go-To-Market guidance. Achieve the top notch position in market. </p>
                 
          </div>
        </div>
      </div> 
      <br/><br/>

      <h1>Standout Features</h1>
        <div className="main-content">
        <div className="image-row">
          <div className="image-content">
            <img src={analysis} alt="Image 1 Alt Text" />
            <h3>Analytics platform</h3>
                <p>A crystal clear single look will provide you with all the
                  <br/> necessary insights for achieving success
                </p>
          </div>
          <div className="image-content">
            <img src={pricing} alt="Image 2 Alt Text" />
            <h3>We make pricing & legal easy</h3>
               <p>Allow our user interface to serve as your dedicated business aides, 
                simplifying your life. You've earned it!  
              </p>
          </div>
          <div className="image-content">
            <img src={partners} alt="Image 3 Alt Text" />
            <h3>Enhance your Microsoft partnership</h3>
            <p>Mark all the partnership criteria as if you're ticking items off a shopping list.</p>
                 
          </div>
        </div>
      </div> 
      <br/>
      <div className="section">
        <img src={secure} alt="Secure Shield" />
        <p>Cloudserve Systems complies with GDPR.</p>
      </div>
      <div className="section">
        <img src={save} alt="Save Money" />
        <p>
          <a href="https://partner.microsoft.com/en-my/asset/collection/marketplace-transact-and-grow-incentive-campaign#/" style={{ textDecoration: 'none', color: 'blue' }}>Publish & Earn</a>
          <br/><br/>
          Cloudserve Systems offers the potential to earn up to 40K from Microsoft for listing on their marketplace.
          <br/> So why wait?
        </p>
      </div>
      <div className="section">
        <img src={send} alt="Send" />
        <p>
          Share the love. Get rewarded.
          <br/> Refer a friend and get 500 Dollars off both bills.
        </p>
      </div>
      <br/>
   
      <section className="pricing-section">
        <h1>Our Pricing</h1>
        <div className="price-toggler">
          <span className={`month ${!isYearly ? 'active' : ''}`} onClick={handleMonthlyClick}>Monthly</span>
          <span className={`year ${isYearly ? 'active' : ''}`} onClick={handleYearlyClick}>Yearly</span>
        </div>

        <div className="pricing-cards">
          {isYearly ? (
            // Yearly pricing cards
            <>
              <div className="pricing-card">
                <h2>Are you a startup?</h2>
                <p>If your company is less than 2 years old. <br/>You're eligible to our start-up pricing.</p>
           
              </div>

              <div className="pricing-card">
                <h2>Grow</h2>
                <p>Our standard offering<br/>
                A one time $5000 setup fee is <br/> charged on top year 1</p>
                <div className="price">$4999.00</div>
                <p><span> &#10003; </span>1 product listing  </p>
                <p> <span> &#10003; </span> Unlimited Customer Offers </p>
                <p> <span> &#10003; </span> Analytics Dashboard </p>
                <p> <span> &#10003; </span> Order Notifications </p>
                <p> <span> &#10003; </span> Go-To-Market consults </p>
                <p> <span> &#10003; </span> Validation of Microsoft partnership criteria </p>
                <a href="">Select</a>
              </div>

              <div className="pricing-card">
                <h2>Add-ons</h2>
                <p>Need some extra?
                charged per year</p>
                <p>Additional product
                    $1000 <br/>
                    Metering reporting
                    $1500</p>
              </div>
            </>
          ) : (
            // Monthly pricing cards
            <>
              <div className="pricing-card">
              <h3>Are you a Start-up?</h3>
               <p>If your company is less than 2 years old. <br/>You're eligible to our start-up pricing.</p>
              </div>

              <div className="pricing-card">
              <h2>Grow</h2>
                <p>Our standard offering<br/>
                A one time $5000 setup fee is <br/> charged on top year 1</p>
                <div className="price">$499.00</div>
                <p><span> &#10003; </span>1 product listing  </p>
                <p> <span> &#10003; </span> Unlimited Customer Offers </p>
                <p> <span> &#10003; </span> Analytics Dashboard </p>
                <p> <span> &#10003; </span> Order Notifications </p>
                <p> <span> &#10003; </span> Go-To-Market consults </p>
                <p> <span> &#10003; </span> Validation of Microsoft partnership criteria </p>
                <a href="">Select</a>
              </div>

              <div className="pricing-card">
              <h3>Add-ons</h3>
               <p>Need some extra?
                charged per year</p>
                <p>Additional product
                    $1000 <br/>
                    Metering reporting
                    $1500</p>
              </div>
            </>
          )}
        </div>
      
      </section>
      <section className="footer">
        

        <div className="icons">
        <br />
            <div className="Contactus">
            <a href="https://www.cloudservesystems.com/contact.html" target="_blank" style={{ color: 'blue' }}><b>Contact Us</b></a> 
            </div>
            <br></br>
            <div className="Policy">
          
            <a href="privacy-policy.html" style={{ color: 'blue' }} target="_blank"><b>Privacy Policy</b></a>
          </div>
          
        </div>
        <p>Copyright @2017 Cloudserve Systems Pvt. Ltd. All rights reserved. </p>
      </section>
    </div>
  );
}

export default Home;
